import React, { useState, useRef, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";

const Dropdown = ({
  options,
  onSelect,
  imgUrl,
  isShouldRotate = false,
  placeholder = "",
  isBig = true,
  initValue = undefined,
  isCitySelected = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState(null);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const [initVal, setInitVal] = useState();
  const [isUsedDefValue, setIsUsedDefValue] = useState(false);
  const { t } = useTranslation();

  // const [filteredOptions, setFilteredOptions] = useState([]);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    setSearchTerm("");
    setInitVal(undefined);
    onSelect(option);
  };

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
  useEffect(() => {
    if (isOpen) {
      setSelected(null);
      setSearchTerm("");
      onSelect(null);

      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    if (options.length > 0 && !isUsedDefValue) {
      setSelected(options.find((el) => el?.value === initValue));
      setIsUsedDefValue(true);
    }
  }, [options]);

  useEffect(() => {
    if (isCitySelected === "") {
      setSelected(null);
    }
  }, [isCitySelected]);

  //test
  React.useEffect(() => {
    setSelected(null);
  }, [isCitySelected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>
      {isOpen ? (
        <div className={`inputContainer ${isBig ? "inputContainer-big" : ""}`}>
          <img
            className={`icon-dropdown ${isOpen && isShouldRotate ? "rotate-symbol" : ""}`}
            alt="icon"
            src={imgUrl}
            onClick={() => toggleDropdown()}
          />
          <input
            type="text"
            placeholder={selected ? selected.label : placeholder}
            className="input"
            ref={inputRef}
            onChange={(el) => setSearchTerm(el.target.value)}
          />
        </div>
      ) : (
        <div className={`dropdown-header ${selected ? "pr-5" : ""}`} onClick={toggleDropdown}>
          <span className={`dropdown-icon`}>
            <img
              className={`icon-dropdown ${isOpen && isShouldRotate ? "rotate-symbol" : ""}`}
              alt={`icon`}
              src={imgUrl}
            />
          </span>
          <p
            style={{
              width: "85%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              direction: "rtl",
            }}
          >
            {initVal ? initVal.label : selected ? selected.label : placeholder}
          </p>
          {selected ? (
            <IconButton
              aria-label="close"
              onClick={(e) => {
                setSelected(null);
                setIsOpen(false);
                setSearchTerm("");
                onSelect(null);
                e.stopPropagation();
              }}
              sx={(theme) => ({
                color: theme.palette.grey[500],
                position: "absolute",
                top: "5px",
                right: "0px",
              })}
            ></IconButton>
          ) : (
            ""
          )}
        </div>
      )}

      {isOpen && (
        <div className="dropdown-menu">
          <ul className="dropdown-list">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <li className="dropdown-item" onClick={() => handleSelect(option)}>
                  {option.label}
                </li>
              ))
            ) : (
              <li className="dropdown-item">{t("NO_RESULTS")}</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
